import { accountSettingsDefaultBillingShippingStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import { css } from "styled-components";

Object.assign(accountSettingsDefaultBillingShippingStyles, {
    ...accountSettingsDefaultBillingShippingStyles,
    defaultBillingShippingTitle: {
        variant: "h2",
        as: "h2",
        css: css`
            width: 100%;
            font-size: 22px;
            padding-bottom: 2px;
            margin: 0;
            color: #252525;
            border-bottom: none;
            text-transform: none;
        `,
    },
    defaultShippingRadioGridItem: {
        width: 12,
        css: css`
            legend[class^="TypographyStyle"] {
                display: none;
            }
            legend[class^="RadioGroupStyle"] {
                display: flex;
                flex-direction: column;
            }
        `,
    },
    defaultShippingRadio: {
        css: css`
            margin-top: 5px !important;
        `,
    },
});
